import { render } from "./AddEncaissement.vue?vue&type=template&id=636f2ad4&scoped=true&ts=true"
import script from "./AddEncaissement.vue?vue&type=script&lang=ts"
export * from "./AddEncaissement.vue?vue&type=script&lang=ts"

import "./AddEncaissement.vue?vue&type=style&index=0&id=636f2ad4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636f2ad4"]])

export default __exports__